__turbopack_context__.v({
  "actions": "success-module__U5Yu_a__actions",
  "card": "success-module__U5Yu_a__card",
  "catalogBtn": "success-module__U5Yu_a__catalogBtn",
  "checkmark": "success-module__U5Yu_a__checkmark",
  "container": "success-module__U5Yu_a__container",
  "homeBtn": "success-module__U5Yu_a__homeBtn",
  "iconWrapper": "success-module__U5Yu_a__iconWrapper",
  "message": "success-module__U5Yu_a__message",
  "orderNumber": "success-module__U5Yu_a__orderNumber",
  "previewGrid": "success-module__U5Yu_a__previewGrid",
  "previewItem": "success-module__U5Yu_a__previewItem",
  "previewTitle": "success-module__U5Yu_a__previewTitle",
  "productsPreview": "success-module__U5Yu_a__productsPreview",
  "scaleIn": "success-module__U5Yu_a__scaleIn",
  "title": "success-module__U5Yu_a__title",
});
